import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateDeviceDocument } from './update.generated';

export const useUpdateDevice = (options: ApiOptions<typeof UpdateDeviceDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(UpdateDeviceDocument, {
    ...useNotifications(UpdateDeviceDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.devices.update_success'),
    }),
    ...options,
  });
};
